import React from 'react';
import "./MutualFund.css"
import "./InvestmentPlan.css"


function InvestmentPlan() {



  return (
    <>
    
    <div className='div5'>



       <div className='description' >
      
     
       
      
        <h1 style={{textAlign:"left", color: "#2196f3"} }>
        What is Systematic Investment Plan (SIP)?
        </h1>

        <div class="list-container1">
    <ul>
      
         <li class="list-item">
        <ul class="sub-list1">
          <li class="list-item"><strong style={{color: "#10b983"}}>Systematic Investment Plan</strong> (SIP) is an investment route offered by Mutual Funds wherein one can invest a fixed amount in a <strong style={{color: "#10b983"}}>Mutual Fund scheme</strong>  at regular intervals</li>
          <li class="list-item">The installment amount could be as little as INR 500 a month and is similar to a recurring deposit.</li>
          <li class="list-item">It’s convenient as you can give your bank standing instructions to debit the amount every month.</li>
          <li class="list-item"><strong style={{color: "#10b983"}}>SIP</strong> has been gaining popularity among Indian MF investors, as it helps in investing in a disciplined manner without worrying about market volatility and timing the market. </li>
          <li class="list-item">Systematic Investment Plans offered by <strong style={{color: "#10b983"}}>Mutual Funds</strong>  are easily the best way to enter the world of investments for the long term. </li>
          <li class="list-item"> It is very important to <strong style={{color: "#10b983"}}>invest for the long-term</strong>, which means that you should start investing early, in order to maximize the end returns.</li>
          <li class="list-item">So your mantra should be - Start Early, Invest Regularly to get the best out of your investments.</li>
          <li class="list-item"> <strong style={{color: "#10b983"}}>Power of Compounding:</strong> SIPs harness the power of compounding to generate wealth over the long term.</li>
          <li class="list-item">  <strong style={{color: "#10b983"}}> By investing regularly </strong>and staying invested for a longer duration, you give your investments more time to grow. Compounding allows you to earn returns not only on your principal amount but also on the returns generated earlier.</li>
          <li class="list-item"> <strong style={{color: "#10b983"}}> Flexibility and Affordability:</strong> SIPs offer flexibility in terms of investment amounts and intervals. You can  <strong style={{color: "#10b983"}}> start with a small investment amount</strong>, such as INR 500, and increase it gradually as your income grows.</li>
        </ul>
      </li>
    </ul>
    <div className='iframe'>
    <iframe width="560" height="415"
     src="https://www.youtube.com/embed/r50yf4d5vRQ"
     title="YouTube video player"
     frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
     allowfullscreen></iframe>
    <div class="credit-container">
<p class="credit-text">
      Powered by <a class="credit-link" href="https://www.mutualfundssahihai.com/en/what-is-a-mutual-fund">Mutual Fund Sahi Hai</a></p>
</div>
    </div>
  </div>
</div>
</div>




    </>
);
}
export default InvestmentPlan;